import MoveIcon from "./MoveIcon";
import { BORDER, TEXT_MUTED } from "../theme";

function PayoffMatrixGrid({ rules, compact = false }) {
  const outcomes = [
    { title: "both trust", myMove: "cooperate", theirMove: "cooperate", myScore: rules.cc },
    { title: "you betray", myMove: "defect", theirMove: "cooperate", myScore: rules.cd_defector },
    { title: "they betray", myMove: "cooperate", theirMove: "defect", myScore: rules.cd_cooperator },
    { title: "both betray", myMove: "defect", theirMove: "defect", myScore: rules.dd },
  ];

  const iconSize = compact ? 16 : 22;

  return (
    <div style={{ border: `1px solid ${BORDER}`, borderRadius: "10px", overflow: "hidden" }}>
      <div style={{ padding: compact ? "6px 10px" : "10px 14px", borderBottom: `1px solid ${BORDER}`, fontSize: compact ? "0.6875rem" : "0.8125rem", fontWeight: "600", textAlign: "center", color: TEXT_MUTED }}>
        today's rules
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}>
        {outcomes.map((outcome, i) => (
          <div
            key={i}
            style={{
              padding: compact ? "8px" : "14px",
              textAlign: "center",
              borderRight: i % 2 === 0 ? `1px solid ${BORDER}` : "none",
              borderBottom: i < 2 ? `1px solid ${BORDER}` : "none",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center", gap: "4px", marginBottom: compact ? "2px" : "6px" }}>
              <MoveIcon move={outcome.myMove} size={iconSize} />
              <MoveIcon move={outcome.theirMove} size={iconSize} flip={outcome.theirMove === "defect"} />
            </div>
            <div style={{ fontSize: compact ? "0.625rem" : "0.75rem", color: TEXT_MUTED, marginBottom: "2px" }}>
              {outcome.title}
            </div>
            <div style={{ fontSize: compact ? "0.75rem" : "1rem", fontWeight: "700" }}>
              {outcome.myScore > 0 ? "+" : ""}{outcome.myScore}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PayoffMatrixGrid;
